import { css } from 'styled-components';

export default css`
  li:nth-child(3) {
    display: inline-block !important;
  }
`;
